<template>
  <div class="result">
    <div class="img" v-if="info.media != null && info.media.value != null">
      <img :src="info.media.value.src" />
    </div>
    <p class="result-correct">{{ correct_result + ' / ' + quiz.questions.length }}</p>
    <p class="description">{{ info.text }}</p>
  </div>
</template>

<script>

export default {
  name: "Result",
  props: ['quiz', 'correct_result'],
  computed: {
    info: function() {
      let infoResult = {}
      const correct_result = this.correct_result
      this.quiz.results.filter(function(result) {
        if (result.from <= correct_result && correct_result <= result.to) {
          infoResult = result
        }
      });
      return infoResult
    }
  }
};
</script>
